
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/gov-files",
      function () {
        return require("private-next-pages/investor/gov-files.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/gov-files"])
      });
    }
  